/**
 * The asset model type indicates what kind of asset it is (e.g. boiler, or tank).
 * This information can also help provide validation for what kinds of components
 * are allowed on an asset (e.g. waterwalls cannot be found in tanks)
 */
export enum GeckoAssetModelType {
  VerticalTank = 'vertical_tank',
  HorizontalTank = 'horizontal_tank',
  Piping = 'piping',
  LegacyBoiler = 'legacy_boiler',
  Ship = 'ship',
  MissileSilo = 'missile_silo',
  NuclearContainmentDome = 'nuclear_containment_dome',
  MachinedForging = 'machined_forging',
  PressureVessel = 'pressure_vessel',
}
/**
 * The asset model component type indicates the metadata that will be found on that
 * component (e.g. TankShell will have a radius and height)
 */
export enum GeckoComponentModelType {
  VerticalTankShell = 'vertical_tank_shell',
  TankFloor = 'tank_floor',
  TankFlatRoof = 'tank_flat_roof',
  HorizontalTankShell = 'horizontal_tank_shell',
  PipeSection = 'pipe_section',
  LegacyBoilerWalls = 'legacy_boiler_walls',
  ShipDeck = 'ship_deck',
  BasicShipHull = 'basic_ship_hull',
  LegacyCone = 'legacy_cone',
  Cone = 'cone',
  LaunchTube = 'launch_tube',
  Dome = 'dome',
  DomeWall = 'dome_wall',
  FlatCircularFloor = 'flat_circular_floor',
  VerticalTankFoundation = 'vertical_tank_foundation',
  MachinedForgingSimple = 'machined_forging_simple',
  PressureVesselShell = 'pressure_vessel_shell',
  HemisphericalHead = 'hemispherical_head',
  TorisphericalHead = 'torispherical_head',
  EllipsoidalHead = 'ellipsoidal_head',
}
/**
 * The asset model feature indicates the metadata that will be found on that component
 * feature (e.g. a Plate will have surface_specs, etc.)
 */
export enum GeckoFeatureModelType {
  Plate = 'plate',
  PolygonalPlate = 'polygonal_plate',
  Course = 'course',
  HorizontalWeld = 'horizontal_weld',
  VerticalWeld = 'vertical_weld',
  Manway = 'manway',
  Nozzle = 'nozzle',
  FixedSensor = 'fixed_sensor',
  LegacyBoilerWall = 'legacy_boiler_wall',
  ShipDeckChock = 'ship_deck_chock',
  ShipDeckBitt = 'ship_deck_bitt',
  ShipDeckHatch = 'ship_deck_hatch',
  PipeNonIntegralSupport = 'pipe_non_integral_support',
  PipeIntegralSupport = 'pipe_integral_support',
  PipeSeamWeld = 'pipe_seam_weld',
  PipeCircumferentialWeld = 'pipe_circumferential_weld',
  PipeWrap = 'pipe_wrap',
  LegacyBoilerRepairRegion = 'legacy_boiler_repair_region',
  ConeCourse = 'cone_course',
  ConePlate = 'cone_plate',
  ConeCircumferentialWeld = 'cone_circumferential_weld',
  ConeRadialWeld = 'cone_radial_weld',
  CoatingRegion = 'coating_region',
  LinerRegion = 'liner_region',
  SphericalPlate = 'spherical_plate',
  LeakDetectionValve = 'leak_detection_valve',
}
